import useSWR from 'swr'
import { COMMUNITY_API_PREFIX } from '../../../shared/api/constants/api-constants'
import { useApiWrapperWithErrorValidation } from '../../../shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from '../../../shared/hooks/use-api-wrapper-with-error-validation/types'
import { CommunityInterface } from '../types/community-interface'

export function useCommunities() {
  const { fetcher } = useApiWrapperWithErrorValidation<
    RequestMethodsEnum.get,
    CommunityInterface[]
  >({ method: RequestMethodsEnum.get })
  return useSWR(() => {
    return COMMUNITY_API_PREFIX
  }, fetcher)
}
